module.exports = __webpack_public_path__ + "img/81ec79b.jpg";